import React from 'react';
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Container, Row, Col } from '../../../../components/ui/wrapper'
import Heading from '../../../../components/ui/heading'
import Text from '../../../../components/ui/text'
import Button from '../../../../components/ui/button'
import TeamMember from '../../../../components/team-member'
import { AboutTeamWrap, TeamWrapper, SectionTitle, ButtonWrap } from './style'
import { useStaticQuery, graphql } from "gatsby"

const TeamsSection = (props) => {
    const TeamPageIntroQueryData = useStaticQuery(graphql`
    query TeamPageIntroDataQuery{
        intro: skills(id: {eq: "team-page-intro"}) {
            title
            desc
            bg_image
          }
        directors: skills(id: {eq: "team-directors"}) {
            directors {
              name
              designation
              email
              phone
              position
              desc
              socials {
                facebook
                instagram
                twitter
            }
              image
            }
          }
    }
`);
    const { intro: { desc, bg_image}, directors: { directors } } = TeamPageIntroQueryData    
    const { headingStyle, textStyle, buttonOneStyle,  teamMemberStyle } = props;

    return (
        <AboutTeamWrap>
        <TeamWrapper src={bg_image}>
            <Container>
                <Row>
                    <Col lg={4}>
                        <SectionTitle>
                            <Heading {...headingStyle}>Our <span>experience experts</span></Heading>
                            <Text {...textStyle}>{desc}</Text>

                            <ButtonWrap>
                                <Button {...buttonOneStyle} to="/careers">Join us now</Button>
                            </ButtonWrap>
                        </SectionTitle>
                    </Col>
                    <Col lg={8}>
                        <Row>
                            {directors.map((team, i) => (
                                <Col md={6} key={`team-${i}`}>
                                    <TeamMember
                                        {...teamMemberStyle}
                                        imageSrc={team.image}
                                        name={team.name}
                                        email={team.email}
                                        phone={team.phone}
                                        designation={team.designation}
                                        social={team.socials}
                                        desc={team.desc}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </TeamWrapper>
        </AboutTeamWrap>
    )
}

TeamsSection.propTypes = {
    headingStyle: PropTypes.object,
    textStyle: PropTypes.object,
    buttonOneStyle: PropTypes.object,
    buttonTwoStyle: PropTypes.object,
    teamMemberStyle: PropTypes.object
}

TeamsSection.defaultProps = {
    headingStyle: {
        as: 'h3',
        child: {
            color: 'primary'
        }
    },
    textStyle: {
        mt: '30px'
    },
    buttonOneStyle: {
        mr: '15px',
        as: Link,
        hover: 2
    },
    buttonTwoStyle: {
        as: Link,
        varient: 'texted',
        fontWeight: 800,
        icondistance: '2px',
        hover: 2
    },
    teamMemberStyle: {
        mb: '60px',
        responsive: {
            small: {
                mb: '30px'
            }
        }
    }
}

export default TeamsSection;